import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import createHandler from "./createHandler";
import { baseGestureHandlerProps } from "./gestureHandlerCommon";
export var nativeViewGestureHandlerProps = [
    "shouldActivateOnStart",
    "disallowInterruption"
];
export var nativeViewProps = _to_consumable_array(baseGestureHandlerProps).concat(_to_consumable_array(nativeViewGestureHandlerProps));
export var nativeViewHandlerName = "NativeViewGestureHandler";
// eslint-disable-next-line @typescript-eslint/no-redeclare -- backward compatibility; see description on the top of gestureHandlerCommon.ts file
export var NativeViewGestureHandler = createHandler({
    name: nativeViewHandlerName,
    allowedProps: nativeViewProps,
    config: {}
});
